import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StorageUtilityLib, USER_SESSION_TOKEN, UserSession } from '@thehubz/client/core';
import { AnyType, vkbTermsAndConditions } from '@thehubz/shared/model';

@Component({
  selector: 'sp-vkb-terms-and-conditions-popup',
  templateUrl: './vkb-terms-and-conditions-popup.component.html',
  styleUrls: ['./vkb-terns-and-conditions-popup.component.scss'],
})
export class VKBTermsNConditionsComponent {
  vkbTermsAndConditions = vkbTermsAndConditions;
  constructor(
    @Inject(USER_SESSION_TOKEN) private userSessionToken: string,
    private storageUtility: StorageUtilityLib,
    @Inject(MAT_DIALOG_DATA) public data: AnyType,
    public dialogRef: MatDialogRef<VKBTermsNConditionsComponent>,
  ) {}

  acceptTnC() {
    const userSession: UserSession = this.storageUtility.getLocalStorage(this.userSessionToken);
    userSession.tncApproved = true;
    this.storageUtility.setLocalStorage(this.userSessionToken, userSession);

    this.dialogRef.close(true);
  }
}
